import { CalendarScheduledSectionServant } from '../servants/calendar_scheduled_section_servant';
import { CalendarTimesModel } from '../models/calendar_times_model';
import { IDefineCommand, IQuery } from 'core-ts-types';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import * as _4 from 'lodash4';
import { ScheduledSectionStatus } from '../../course_scheduler/types/scheduled_section_status_enum';
import { ClearCalendarSectionTimesCommand } from './clear_calendar_section_times_command';

export type UpdateCalendarSectionTimesCommand = (builtSections?: ISection[]) => ng.IPromise<IQuery>;

angular
  .module('capability-ng-scheduler')
  .service(
    'updateCalendarSectionTimesCommand',
    (
      defineCommandORM: IDefineCommand,
      ngCalendarTimesModel: CalendarTimesModel,
      ngSectionsDatasource: ISectionsDatasource,
      ngCalendarScheduledSectionServant: CalendarScheduledSectionServant,
      clearCalendarSectionTimesCommand: ClearCalendarSectionTimesCommand
    ) => {
      return defineCommandORM('updateCalendarSectionTimesCommand', (deferred, builtSections?: ISection[]) => {
        clearCalendarSectionTimesCommand().then(() => {
          if (!builtSections) {
            const sectionsWithStatus = _4.filter(
              ngSectionsDatasource.read(),
              (section) => section.status !== ScheduledSectionStatus.UNSCHEDULED
            );
            builtSections = ngSectionsDatasource.metasource().composes(sectionsWithStatus);
          }
          ngCalendarTimesModel.write({
            section_times: ngCalendarScheduledSectionServant.buildCalendarSections(builtSections),
            loaded_times: true
          });
          deferred.resolve();
        });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/calendar/commands/update_calendar_section_times_command.ts